import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfigModule } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AuthGuard } from '../../../../core/auth';
import { MypageMenuListItemModule } from '../../components/my-page-menu-list-item/my-page-menu-list-item.module';
import { NavigationModule } from '../navigation';
import { MyPageMenuComponent } from './my-page-menu.component';

@NgModule({
  declarations: [MyPageMenuComponent],
  imports: [
    CommonModule,
    MypageMenuListItemModule,
    NavigationModule,
    RouterModule,
    NgbCollapseModule,
    NzIconModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CmsMyPageMenuComponent: {
          component: MyPageMenuComponent,
          guards: [AuthGuard],
        },
      },
    }),
  ],
  providers: [],
  exports: [],
})
export class MyPageMenuModule {}
